export class CancellationToken {

	private canceled: boolean = false;

	public isCanceled = (): boolean => this.canceled;

	public cancel = () => this.canceled = true;
}
